import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { toEmbedUrl } from "../../lib/api";

export const VideoModal = ({ project, onClose }) => {
  const embed = project ? toEmbedUrl(project.video_url) : null;

  return (
    <AnimatePresence>
      {project && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          style={{ background: "rgba(3,3,3,0.92)", backdropFilter: "blur(6px)" }}
          data-testid="video-modal"
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 p-2 text-white/70 hover:text-white transition-colors"
            data-testid="video-modal-close"
            aria-label="close"
          >
            <X size={28} />
          </button>

          <motion.div
            initial={{ scale: 0.94, y: 20, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="w-full max-w-5xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="relative w-full overflow-hidden rounded-xl border"
              style={{ borderColor: "var(--border-color)", aspectRatio: "16/9", background: "#000" }}
            >
              {embed ? (
                <iframe
                  src={embed}
                  title={project.title}
                  className="absolute inset-0 w-full h-full"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                />
              ) : project.video_url ? (
                <video src={project.video_url} controls autoPlay className="absolute inset-0 w-full h-full object-contain" />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center text-white/50">No video URL set</div>
              )}
            </div>
            <div className="mt-5 flex flex-wrap items-baseline justify-between gap-2">
              <div>
                <h3 className="font-heading text-xl md:text-2xl font-semibold">{project.title}</h3>
                <p className="text-sm" style={{ color: "var(--text-secondary)" }}>{project.description}</p>
              </div>
              <span className="text-xs uppercase tracking-[0.25em]" style={{ color: "var(--accent-color)" }}>
                {project.category}
              </span>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
